import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import TextError from "components/TextError";
import * as _ from "lodash";
import { DepartmentList, CreateDepartment } from "services/api/department";
import { ProfileList } from "services/api/profile";
import Select from "react-select";
import toast from "react-hot-toast";
import { updateUser } from "services/api/user";

import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

const options = [];
const roleOption = [];

function EditForm({
  editShow,
  seteditShow,
  refresh,
  setRefresh,
  selectedUser,
}) {
  console.log(selectedUser.department.id);

  const [validate, setValidate] = useState(false);
  const [emailVal, setEmailVal] = useState(false);
  const [contactVal, setContactVal] = useState(false);
  const [usernameVal, setUsernameVal] = useState(false);
  const [deparmentList, setDeparmentList] = useState();
  const [roleList, setRoleList] = useState();

  const [selectedOption, setSelectedOption] = useState();
  const [selectedRole, setSelectedRole] = useState();

  const [modelData, setModelData] = useState({
    name: selectedUser.name || "",
    department: selectedUser.department?.id || "",
    profile: selectedUser.profile?.id || "",
  });

  const roleOptions = [
    { value: "Admin", label: "Admin" },
    { value: "User", label: "User" },
    { value: "Guest", label: "Guest" },
  ];

  useEffect(() => {
    async function getData() {
      let res = await DepartmentList({ status: 1 });
      setDeparmentList(res?.data?.data);

      let response = await ProfileList({ status: 1 });
      setRoleList(response?.data?.data);

      res?.data?.data.forEach((e) => {
        options.push({ value: e._id, label: e.name });
      });

      response?.data?.data.forEach((e) => {
        roleOption.push({ value: e._id, label: e.name });
      });
    }
    getData();
  }, []);
  const handleClose = () => {
    seteditShow(false);
  };

  const isFormChanged = () => {
  return (
    modelData.name !== selectedUser.name ||
    modelData.department !== selectedUser.department?.id ||
    modelData.profile !== selectedUser.profile?.id
  );
};

  const handleSubmit = async () => {

    
    setValidate(true);
     
 if (!isFormChanged()) {
    toast.error("No changes detected.");
    return;
  }

    const updatedData = {
      name: modelData.name,
      department: modelData.department,
      profile: modelData.profile,
    };

    try {
      const res = await updateUser(selectedUser._id, updatedData); // replace with your real API call
      if (res?.data?.success) {
        toast.success("User updated successfully");
        seteditShow(false);
        setRefresh((prev) => !prev);
      } else {
        toast.error("Failed to update user");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Modal show={editShow} onHide={handleClose}>
        <Modal.Body>
          <Container>
            <Row className="justify-content-center ">
              <Col lg="12 p-0">
                <Card className="bg-secondary shadow border-0 ">
                  <CardBody>
                    <div className="text-center mb-4">
                      <h4 className="text-primary font-weight-bold">
                        EDIT USER
                      </h4>
                    </div>
                    <Form role="form">
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-hat-3" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Name"
                            type="text"
                            value={modelData.name}
                            onChange={(e) =>
                              setModelData({
                                ...modelData,
                                name: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                        {validate && !modelData.name ? (
                          <TextError children={"This field is required"} />
                        ) : null}
                      </FormGroup>
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-hat-3" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Username"
                            type="text"
                            value={selectedUser.username}
                            onChange={(e) => {
                              if (!isNaN(e.target.value)) {
                                if (e.target.value.trim().length == 8) {
                                  setUsernameVal(false);
                                } else {
                                  setUsernameVal(true);
                                }
                                setModelData({
                                  ...modelData,
                                  username: e.target.value.trim(),
                                });
                              }
                            }}
                            readOnly
                          />
                        </InputGroup>
                    
                      </FormGroup>

                      <FormGroup>
                        <Select
                          placeholder="Select Department..."
                          onChange={(option) => {
                            setSelectedOption(option);
                            setModelData({
                              ...modelData,
                              department: option.value,
                            });
                          }}
                          options={options}
                          value={options.find(
                            (option) => option.value === modelData.department
                          )}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Select
                          placeholder="Select Profile..."
                          onChange={(option) => {
                            setSelectedRole(option);
                            setModelData({ ...modelData, profile: option.value });
                          }}
                          options={roleOption}
                          value={roleOption.find(
                            (option) => option.value === modelData.profile
                          )}
                        />
                      </FormGroup>

                      <div className="text-right">
                        <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button>
                        <Button
                          className=""
                          color="primary"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default EditForm;
